export const HelpMap = {
  CONTAINER_WIDGET: {
    path: "/widget-reference/container",
    searchKey: "Container",
  },
  FUNCTION_WIDGET: {
    path: "/widget-reference/container",
    searchKey: "Function",
  },

  TEMPLATE_WIDGET: {
    path: "/widget-reference/container",
    searchKey: "Container",
  },
  CHECKBOX_WIDGET: {
    path: "/widget-reference/checkbox",
    searchKey: "Checkbox",
  },
  BUTTON_WIDGET: {
    path: "/widget-reference/button",
    searchKey: "Button",
  },
  TEXT_WIDGET: {
    path: "/widget-reference/text",
    searchKey: "Text",
  },
  TRANSFORMERS_WIDGET: {
    path: "/widget-reference/transformers",
    searchKey: "transformers",
  },
  IFRAME_WIDGET: {
    path: "/widget-reference/iframe",
    searchKey: "transformers",
  },
  SLIDER_WIDGET: {
    path: "/widget-reference/slider",
    searchKey: "Slider",
  },
  LABEL_WIDGET: {
    path: "/widget-reference/label",
    searchKey: "Label",
  },
  FILE_PICKER_S3_WIDGET: {
    path: "/widget-reference/filepicker",
    searchKey: "FilePicker",
  },
  IMAGE_WIDGET: {
    path: "/widget-reference/image",
    searchKey: "Image",
  },
  MOB_HEADER_WIDGET: {
    path: "/widget-reference/header",
    searchKey: "Header",
  },
  REPEAT_WIDGET: {
    path: "/widget-reference/repeat",
    searchKey: "Repeat",
  },
  INPUT_WIDGET: {
    path: "/widget-reference/input",
    searchKey: "Input",
  },
  DATE_PICKER_WIDGET: {
    path: "/widget-reference/datepicker",
    searchKey: "DatePicker",
  },
  TABLE_WIDGET: {
    path: "/widget-reference/table",
    searchKey: "Table",
  },
  VIDEO_WIDGET: {
    path: "/widget-reference/video",
    searchKey: "Video",
  },
  DROP_DOWN_WIDGET: {
    path: "/widget-reference/dropdown",
    searchKey: "Dropdown",
  },
  RADIO_GROUP_WIDGET: {
    path: "/widget-reference/radio",
    searchKey: "Radio",
  },
  RICH_TEXT_EDITOR_WIDGET: {
    path: "",
    searchKey: "Rich Text Editor",
  },
  CHART_WIDGET: {
    path: "/widget-reference/chart",
    searchKey: "Chart",
  },
  FORM_WIDGET: {
    path: "/widget-reference/form",
    searchKey: "Form",
  },
  FILE_PICKER_WIDGET: {
    path: "/widget-reference/filepicker",
    searchKey: "File picker",
  },
  FORM_BUTTON_WIDGET: {
    path: "",
    searchKey: "",
  },
  CANVAS_WIDGET: {
    path: "",
    searchKey: "",
  },
  ICON_WIDGET: {
    path: "",
    searchKey: "",
  },
  SKELETON_WIDGET: {
    path: "",
    searchKey: "",
  },
  TABS_WIDGET: {
    path: "",
    searchKey: "Tabs",
  },
  ACCORDION_WIDGET: {
    path: "",
    searchKey: "",
  },
  KANBAN_BOARD_WIDGET: {
    path: "",
    searchKey: "Tabs",
  },
  FILE_MANAGER: {
    path: "",
    searchKey: "",
  },
  MODAL_WIDGET: {
    path: "",
    searchKey: "",
  },
  REPEAT_MODAL_WIDGET: {
    path: "",
    searchKey: "",
  },
  TRANSFORM_WIDGET: {
    path: "",
    searchKey: "",
  },
  MAP_WIDGET: {
    path: "",
    searchKey: "Map",
  },
  API_MAIN: {
    path: "/core-concepts/apis",
    searchKey: "Apis",
  },
  API_BINDING: {
    path: "/core-concepts/apis/taking-inputs-from-widgets",
    searchKey: "Taking Inputs from Widgets",
  },
  DATASOURCE_FORM: {
    path: "/core-concepts/connecting-to-databases",
    searchKey: "Connecting to databases",
  },
};

export const HelpBaseURL = "https://ubraine.com";
